export default "__VITE_ASSET__CQU4j7nI__"